/**
 * 단체판매(bulk-sale) 페이지 경유 PDP 장바구니 담기 차단
 *
 * bulk-sale 페이지(/pages/bulk-sale)에서 상품 링크를 클릭하면 그 시점에
 * sessionStorage 에 대상 상품 handle 을 기록한다. 그 상품 PDP 에 도착하면 플래그를
 * 1회 읽고 즉시 소비(삭제)하여 "이 도착이 bulk-sale 경유인지"만 표시(pageBlocked)한다.
 * 이후 "카트에 추가"(메인 ATC [data-atc-btn] / 모바일 드로어 hidden
 * [data-pdp-hidden-cart-btn]) 클릭을 capture phase 로 가로채 open-cart-modal
 * 디스패치를 차단하고 안내 팝업을 노출한다.
 *
 * - 도착 시 1회 소비 → 로고/검색/다른 경로로 같은 상품 PDP 에 재진입하면 플래그가
 *   없으므로 정상 동작(차단 안 함). 같은 페이지 내 재클릭은 pageBlocked 로 계속 차단.
 * - prerender(theme.liquid speculation rules) 안전: prerender 중이면 활성화
 *   (prerenderingchange) 후 평가하므로, 클릭→플래그기록→활성화 순서가 보장된다.
 *
 * 스코프: bulk-sale 에서 클릭한 그 상품 PDP 의 "그 도착"에서만 차단(handle 매칭).
 */
(function () {
  var KEY = 'fila_bulk_sale_funnel';
  var EXPIRY_MS = 30 * 60 * 1000;
  var pageBlocked = false;
  var PRODUCT_FORM_SELECTOR = 'product-form form[data-type="add-to-cart-form"]';

  function currentHandle() {
    var m = window.location.pathname.match(/\/products\/([^/?#]+)/);
    return m ? m[1] : null;
  }

  // bulk-sale 페이지: 상품 링크 클릭 시점에 funnel 플래그(handle) 기록.
  // 실 클릭은 prerender 활성화 직전에 동기 실행되므로 PDP 도달 전 항상 기록된다.
  if (window.__BULK_SALE_PAGE === true) {
    document.addEventListener('click', function (e) {
      var a = e.target.closest('a[href]');
      if (!a) return;
      var m = (a.getAttribute('href') || '').match(/\/products\/([^/?#]+)/);
      if (!m) return;
      try {
        sessionStorage.setItem(KEY, JSON.stringify({ handle: m[1], ts: Date.now() }));
      } catch (e) {}
    }, true);
  }

  // PDP 도착 시 1회 평가 + 소비 → 이 도착이 bulk-sale 경유면 pageBlocked = true.
  function evaluateFunnel() {
    var handle = currentHandle();
    if (handle) {
      try {
        var raw = sessionStorage.getItem(KEY);
        if (raw) {
          var f = JSON.parse(raw);
          if (f && f.handle === handle && (Date.now() - f.ts) < EXPIRY_MS) {
            pageBlocked = true;
            sessionStorage.removeItem(KEY); // 1회 소비 → 타경로 재진입 시 정상 동작
            return;
          }
        }
      } catch (e) {}
    }
    // 보조: 해당 상품 URL 에 ?bulk_sale=1 이 직접 부착된 경우 (featured-collection 서버 렌더)
    try {
      if (new URLSearchParams(window.location.search).get('bulk_sale') === '1') pageBlocked = true;
    } catch (e) {}
  }

  // prerender 중이면 활성화 후 평가(클릭→플래그기록→활성화 순서 보장), 아니면 즉시.
  if (document.prerendering) {
    document.addEventListener('prerenderingchange', evaluateFunnel, { once: true });
  } else {
    evaluateFunnel();
  }

  var popupEl = null;

  function ensurePopup() {
    if (popupEl) return;

    var style = document.createElement('style');
    style.textContent =
      '.bulk-sale-popup{position:fixed;top:0;left:0;width:100%;height:100%;z-index:99999;display:flex;align-items:center;justify-content:center;opacity:0;visibility:hidden;transition:opacity .3s,visibility .3s}' +
      '.bulk-sale-popup--active{opacity:1;visibility:visible}' +
      '.bulk-sale-popup__overlay{position:absolute;top:0;left:0;width:100%;height:100%;background:rgba(0,0,0,.5);cursor:pointer}' +
      '.bulk-sale-popup__dialog{position:relative;background:#fff;padding:40px 32px 32px;max-width:400px;width:85%;border-radius:8px;box-shadow:0 4px 20px rgba(0,0,0,.15);z-index:1;text-align:center}' +
      '.bulk-sale-popup__title{font-size:1.8rem;font-weight:700;margin:0 0 16px;color:#000;line-height:1.3}' +
      '.bulk-sale-popup__body{font-size:1.4rem;color:#333;margin:0 0 28px;line-height:1.6}' +
      '.bulk-sale-popup__actions{display:flex;gap:12px;justify-content:center}' +
      '.bulk-sale-popup__btn{flex:1;max-width:140px;padding:12px 0;border-radius:50px;font-size:1.4rem;font-weight:500;cursor:pointer;transition:opacity .3s;background:#000;color:#fff;border:none}' +
      '.bulk-sale-popup__btn:hover{opacity:.8}';
    document.head.appendChild(style);

    popupEl = document.createElement('div');
    popupEl.className = 'bulk-sale-popup';
    popupEl.innerHTML =
      '<div class="bulk-sale-popup__overlay" data-bulk-sale-popup-close></div>' +
      '<div class="bulk-sale-popup__dialog" role="dialog" aria-modal="true">' +
        '<h2 class="bulk-sale-popup__title">단체 구매 안내</h2>' +
        '<p class="bulk-sale-popup__body">단체 구매 문의는 영업 담당자에게 문의해주세요.</p>' +
        '<div class="bulk-sale-popup__actions">' +
          '<button type="button" class="bulk-sale-popup__btn" data-bulk-sale-popup-close>확인</button>' +
        '</div>' +
      '</div>';
    document.body.appendChild(popupEl);

    popupEl.querySelectorAll('[data-bulk-sale-popup-close]').forEach(function (el) {
      el.addEventListener('click', closePopup);
    });
    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape' && popupEl && popupEl.classList.contains('bulk-sale-popup--active')) {
        closePopup();
      }
    });
  }

  function openPopup() {
    ensurePopup();
    popupEl.classList.add('bulk-sale-popup--active');
    document.body.style.overflow = 'hidden';
  }

  function closePopup() {
    if (!popupEl) return;
    popupEl.classList.remove('bulk-sale-popup--active');
    document.body.style.overflow = '';
  }

  function isEligibleButton(btn) {
    if (!btn) return false;
    if (btn.hasAttribute('data-no-variant-selected')) return false;
    if (btn.hasAttribute('disabled')) return false;
    if (btn.getAttribute('aria-disabled') === 'true') return false;
    return true;
  }

  // PDP ATC 인터셉트 — open-cart-modal 디스패치 차단. 같은 페이지 내 재클릭도 계속 차단.
  // (추천상품 등 다른 카드의 quick-add 는 대상 아님)
  document.addEventListener('click', function (e) {
    if (!pageBlocked) return;

    var btn = e.target.closest('button[data-atc-btn], button[data-pdp-hidden-cart-btn]');
    if (!isEligibleButton(btn)) return;

    e.stopImmediatePropagation();
    e.preventDefault();
    openPopup();
  }, true);

  // click 인터셉트가 누락되더라도 실제 장바구니 submit 직전 최종 차단.
  document.addEventListener('submit', function (e) {
    if (!pageBlocked) return;

    var form = e.target.closest(PRODUCT_FORM_SELECTOR);
    if (!form) return;

    var btn = form.closest('product-form')?.querySelector('button[data-atc-btn]');
    if (!isEligibleButton(btn)) return;

    e.stopImmediatePropagation();
    e.preventDefault();
    openPopup();
  }, true);

  // product-form.js onSubmitHandler 등 외부에서 호출 (PLP submit 경로)
  window.BulkSaleCheck = {
    check: function () {
      if (!pageBlocked) return false;
      openPopup();
      return true;
    }
  };
})();
